import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getDepartmentStore = (state: RootState) => state.departmentStore;
const getDepartment = createSelector(getDepartmentStore, (state) => state.departments);
const getLearningInfo = createSelector(getDepartmentStore, (state) => state.learningInfo);

export { getDepartment, getLearningInfo };
